var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.creneau.remplace || _vm.remplacePar)?_c('v-list-item',{on:{"click":function($event){return _vm.annulerRemplacement()}}},[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"grey"}},[_vm._v("fa-people-arrows")])],1),_c('v-list-item-title',[_vm._v("Annuler le remplacement")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }